import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from '../../../api/services';
import { AuthService } from '../../../auth/auth.service';
import { UserConfigService } from '../../user-config.service';
import { showOnboarding } from '../../onboarding';

@Injectable()
export class CanActivateOnboarding implements CanActivate {
  constructor(
    public users: UsersService,
    private authService: AuthService,
    private userConfig: UserConfigService,
    private matDialog: MatDialog
  ) {}

  canActivate(): Observable<boolean> | boolean {
    const isLoggedIn = this.authService.isLoggedIn();
    if (!isLoggedIn) {
      return true;
    }
    return this.authService.currentUserInfo$.pipe(
      tap((userInfo) => {
        if (userInfo) {
          this.showOnboardingIfNeeded();
        }
      }),
      map(() => {
        return true;
      })
    );
  }

  private async showOnboardingIfNeeded() {
    // Check if onboarding was already seen or should be skipped
    const urlParams = new URLSearchParams(window.location.search);
    const alreadySeen = await this.userConfig.get('qa.onboarding.seen');
    const skippedPreviously = await this.userConfig.get(
      'qa.onboarding.skipped'
    );
    if (
      urlParams.get('skipOnboarding') === 'true' ||
      alreadySeen ||
      skippedPreviously
    )
      return;
    await showOnboarding(this.matDialog);
  }
}
